import { render, staticRenderFns } from "./clian.vue?vue&type=template&id=23fca182&scoped=true&"
import script from "./clian.vue?vue&type=script&lang=js&"
export * from "./clian.vue?vue&type=script&lang=js&"
import style0 from "./clian.vue?vue&type=style&index=0&id=23fca182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fca182",
  null
  
)

export default component.exports